import { Box, Heading, Skeleton } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { useGetBorrowingBaseReportQuery } from 'packages/borrowing-base/requests/borrowingBase.gql.generated';
import { BorrowingBaseSummaryWithSingleValue } from 'packages/borrowing-base/ui/borrowingBaseSummary/BorrowingBaseSummaryWithSingleValue';
import { BorrowingBaseSummarySections } from 'packages/borrowing-base/ui/borrowingBaseSummary/utils';
import { colors } from 'packages/common-frontend/colors';

export type DigitalMonthlyReportBorrowingBaseSection =
  | 'all'
  | 'receivables'
  | 'cash'
  | 'finalBorrowingBaseReport';
type DigitalMonthlyReportBorrowingBaseProps = {
  creditAgreement: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
  borrowingBaseReportId: string;
  section: DigitalMonthlyReportBorrowingBaseSection;
};
export const DigitalMonthlyReportBorrowingBase = ({
  creditAgreement,
  borrowingBaseReportId,
  section,
}: DigitalMonthlyReportBorrowingBaseProps) => {
  const requestedSections = useMemo(() => {
    switch (section) {
      case 'all':
        return [
          BorrowingBaseSummarySections.receivables,
          BorrowingBaseSummarySections.cash,
          BorrowingBaseSummarySections.finalBorrowingBaseReport,
        ];
      default:
        return [BorrowingBaseSummarySections[section]];
    }
  }, [section]);

  const {
    data: borrowingBaseReportData,
    loading: isBorrowingBaseReportLoading,
  } = useGetBorrowingBaseReportQuery({ variables: { borrowingBaseReportId } });

  if (!borrowingBaseReportData || isBorrowingBaseReportLoading) {
    return <Skeleton h="600px" />;
  }

  return (
    <Box
      backgroundColor="white"
      borderRadius="8px"
      borderWidth="1px"
      borderColor={colors.gray[200]}
      padding="40px"
    >
      {section === 'all' ? (
        <Heading as="h2" fontSize="24px" mb="40px">
          Borrowing Base
        </Heading>
      ) : null}
      <BorrowingBaseSummaryWithSingleValue
        borrowingBaseReport={borrowingBaseReportData.borrowingBaseReport}
        creditAgreement={creditAgreement}
        sections={requestedSections}
      />
    </Box>
  );
};
